import React from 'react';
import { Alert, Button, Drawer, Space } from 'antd';
import { QuotationRevisionComparePanel } from '@/components/crm/QuotationRevisionComparePanel';
import type { Quotation } from '@/services/quotation.service';

type Props = {
  open: boolean;
  quotation: Quotation;
  onClose: () => void;
};

export const QuotationCompareDrawer: React.FC<Props> = ({ open, quotation, onClose }) => {
  return (
    <Drawer
      title={`Compare revisions — ${quotation.quotation_number}`}
      open={open}
      onClose={onClose}
      width={Math.min(920, typeof window !== 'undefined' ? window.innerWidth - 24 : 920)}
      destroyOnClose
    >
      <QuotationRevisionComparePanel quotation={quotation} embedded />
    </Drawer>
  );
};

export default QuotationCompareDrawer;
